import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { PolarisFormProvider } from '@container';
import translations from '@shopify/polaris/locales/es.json';
import { TransferForm, TransferShippingModal, QuantityProgress } from '@presentational';
import { AppProvider, Badge, Card, Frame, Toast } from '@shopify/polaris';
import { buildShipHeroURL } from 'utils'; 

import axiosRails from '@utils/axios';

const propTypes = {
  transfer: PropTypes.object.isRequired,
  submitURL: PropTypes.string.isRequired,
  shippingURL: PropTypes.string.isRequired,
  isSeller: PropTypes.bool, // Indicates if current user is the SELLER or just an admin. Only sellers can add more products. or SHIP
  canShipItems: PropTypes.bool,
  deleteURL: PropTypes.string,
  isAdmin: PropTypes.bool,
};

const defaultProps = {
  deleteURL: ""
}

class TransferEditContainer extends Component {
  constructor(props) {
    super(props);
    let stuff = this.parseTransfer(props.transfer)
    this.state = {
      //...defaultValues // When using polaris instead of formik
      ...stuff,
      method: "PATCH",
      modalActive: false,
      loading: false,

      shippingToastMessage: "",
    }
  }

  parseTransfer = (transfer) => {
    const defaultValues = { // aka initialValues
      ...transfer,
      products_transfers_attributes: transfer.products_transfers,
      products_transfers: null,
    }
    const stableProductTransfers = transfer.products_transfers.map((pt) => ({ ...pt, to_ship: 0 })); // add virtual attribute
    return { 
      defaultValues, 
      originalItems: stableProductTransfers 
    }
  }

  render() {
    let { defaultValues, method } = this.state;
    let { submitURL, queryURL, isSeller, canShipItems, isAdmin } = this.props;

    const currentStatus = defaultValues.status;
    const currentSaleStatus = defaultValues.sale_status.replace("sale_","");
    const currentSaleStatusParsed = defaultValues.sale_status.replace("sale_","");

    const shipHeroURL = isAdmin && buildShipHeroURL(defaultValues.ship_hero_po_id);
    console.log(this.props);
    return (
      <div>
        <PolarisFormProvider
          title={I18n.t("activerecord.models.transfer.one")}
          defaultValues={defaultValues}
          submitURL={submitURL}
          submitMethod={method}
          paramsName="transfer"
          pageProps={{
            fullWidth: true,
            breadcrumbs: [{content: I18n.t("actions.back"), url: '/transfers'}],
          }}
        >
          {(renderProps) =>
            <div>
              
              <div className="flex">

                <div className={`mb30 flexContainer statusProgressContainer ${currentStatus}`}>
                  <Card>
                    <div className="statusLabel">
                      { I18n.t("activerecord.attributes.transfer.status") } 
                      <br/>
                      { I18n.t(`enum.status.${currentStatus}`) }
                    </div>

                    <QuantityProgress
                      quantity={defaultValues.total_shipped}
                      total={defaultValues.total_to_ship}
                      textStyle={{
                        textAlign: "center"
                      }}
                    />
                  </Card>
                </div>
                
                <div className={`mb30 flexContainer statusProgressContainer ${currentSaleStatusParsed}`}>
                  <Card>
                    <div className="statusLabel">
                      { I18n.t("activerecord.attributes.transfer.sale_status") } 
                      <br/>
                      { I18n.t(`enum.status.${currentSaleStatus}`) }
                    </div>

                    <QuantityProgress
                      quantity={defaultValues.total_sold}
                      total={defaultValues.total_to_ship}
                      textStyle={{
                        textAlign: "center"
                      }}
                    />
                  </Card>
                </div>

              </div>
  
              <TransferForm
                update
                isSeller={ isSeller }
                canShipItems={ canShipItems }
                deleteURL={ this.props.deleteURL }
                completed={ defaultValues.status == "completed" }
                queryURL={queryURL}
                onSelection={renderProps.pushNewValue}
                renderItem={this.renderItem}
                onShippingClick={ this.openModal }
                loading={ renderProps.status.submitLoading || this.state.loading }
                {...renderProps} />
            </div>
          }
        </PolarisFormProvider>

        {/* Handle different formik (shipping modal one) */}
        { canShipItems &&
          <AppProvider i18n={translations}>
            <Frame>
              <div>
                <Formik 
                  initialValues={{
                    items: this.state.originalItems 
                  }}
                  onSubmit={ this.submitShipping }
                  enableReinitialize
                  render={ ({values, setFieldValue, handleSubmit, handleReset}) => 
                    <TransferShippingModal
                      open={this.state.modalActive}
                      onClose={this.closeModal}
                      items={ values.items}
                      primaryAction={ handleSubmit }
                      secondaryAction={ handleReset }
                      handleChange={ setFieldValue }
                      loading={ this.state.loading }
                    />
                  }
                />
                { !!this.state.shippingToastMessage ?
                  <Toast 
                    content={this.state.shippingToastMessage} 
                    onDismiss={ () => this.setState({shippingToastMessage: ""}) } />
                  : null
                }
                </div>
            </Frame>
          </AppProvider>
        }
      </div>
    );
  }

  openModal = () => this.setState({ modalActive: true });
  closeModal = () => this.setState({ modalActive: false });

  submitShipping = async (values) => {
    console.log(values);
    let shippingToast = "";
    await this.setState({ loading: true });
    
    let response = await axiosRails.post(this.props.shippingURL, {
      transfer_shipping: values
    });

    console.log("Shp", response);
    if(response.data.success){
      // console.log("RELOADING VALUES");

      if(response.data.failures.length > 0){
        shippingToast = I18n.t("app.messages.transfer_failed_for_some_records")
        // alert("Some records couldn't be updated!");
        // console.log(response.data.failures);
      }
      else{
        shippingToast = I18n.t("app.messages.transfer_success")
      }
      
      let parsedData = this.parseTransfer(response.data.transfer);

      await this.setState({ 
        ...parsedData,
        loading: false,
        shippingToastMessage: shippingToast
       });
    }
    else{
      // alert(`An error ocurred ${response.data.message}`)
      await this.setState({ 
        loading: false,
        shippingToastMessage: I18n.t("app.messages.request_error")
      });
    }
  }
}


TransferEditContainer.propTypes = propTypes;
TransferEditContainer.defaultProps = defaultProps;


export default TransferEditContainer;
